import { captureException } from '@sentry/nextjs';
import { SendTransactionResult } from '@wagmi/core';
import { MutationFunction, useMutation } from 'react-query';

export type UseRevivalType = {
  data: any;
  sendTransactionAsync: (any) => Promise<SendTransactionResult>;
};

// create transaction that user must sign in metamask
const useTransaction: MutationFunction<any, UseRevivalType> = async ({
  data,
  sendTransactionAsync,
}) => {
  try {
    let transactionParameters = data['transaction'];
    transactionParameters = (({ chainId, data, from, to, value }) => ({
      chainId,
      data,
      from,
      to,
      value,
    }))(transactionParameters);
    const transaction = await sendTransactionAsync({
      recklesslySetUnpreparedRequest: transactionParameters,
    });
    return transaction.hash;
  } catch (err: any) {
    captureException(err);
    throw new Error(err?.message || 'Set transaction error');
  }
};

export const useSetTransaction = () => {
  return useMutation(useTransaction, {
    retry: (_retryAttempt, error: any) => {
      // dont retry if user cancelled request
      if (error?.message === 'User rejected request') {
        return false;
      }
      return true;
    },
  });
};
